import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminApprovals = lazy(() => import("@/pages/admin/AdminApprovals"));

export const Route = createFileRoute("/admin/godkannanden")({
  component: () => <AdminApprovals />,
});
